import React from "react";
import { Dialog, Grid, DialogActions, Slide, Toolbar, IconButton, AppBar, Typography, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { osName, osVersion } from "react-device-detect";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "sticky",
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    color: theme.palette.getContrastText(theme.palette.background.default),
  },
}));

export default function ResponsiveDialog(props) {
  const { children, open, setOpen, title, actionButton, fullScreen } = props;
  const classes = useStyles();
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClose = () => {
    setOpen(false);
  };
  //        <div className="ectool-safe-area-top"></div>
  return (
    <Dialog
      fullScreen={smallScreen || fullScreen}
      TransitionComponent={Transition}
      open={open}
      onClose={handleClose}
      fullWidth
      aria-labelledby="responsive-dialog-title"
      scroll="paper"
      maxWidth={props.maxWidth ? props.maxWidth : "lg"}
    >
      <AppBar className={classes.appBar}>
        {osName === "Android" && Number(osVersion) >= 15 ? <div className="ectool-safe-area-top"></div> : <div className="ectool-safe-area-top"></div>}
        <Toolbar>
          <IconButton edge="start" color="primary" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      {children}
      {actionButton && (
        <DialogActions>
          <Grid container justifyContent="flex-end">
            <Grid item xs={12} style={{ display: "flex", flexDirection: "row-reverse" }}>
              {actionButton}
            </Grid>
            <Grid item xs={12}>
              {osName === "Android" && Number(osVersion) >= 15 ? <div className="ectool-safe-area-top"></div> : <div className="ectool-safe-area-top"></div>}
            </Grid>
          </Grid>
        </DialogActions>
      )}
    </Dialog>
  );
}

ResponsiveDialog.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object), PropTypes.node]),
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  setOpen: PropTypes.func.isRequired,
  actionButton: PropTypes.object,
};
